import React from 'react'
import Navigation from '../navigation'
import withPositionFixed from '../../../common/components/with-position-fixed'

const positionProps = {
  left: '0',
  top: '0',
  width: '100%',
  zIndex: '100',
}

const Header = () => {
  return (
    <div className="header">
      <Navigation />
    </div>
  )
}

export default withPositionFixed(Header, positionProps)



// WEBPACK FOOTER //
// ./src/mobile/components/header/index.js